import { render, staticRenderFns } from "./Jitsi.vue?vue&type=template&id=61b7f61e&scoped=true"
import script from "./Jitsi.vue?vue&type=script&lang=js"
export * from "./Jitsi.vue?vue&type=script&lang=js"
import style0 from "./Jitsi.vue?vue&type=style&index=0&id=61b7f61e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b7f61e",
  null
  
)

export default component.exports